import { Link } from "react-router-dom";
import { Phone, Mail, ArrowUpRight } from "lucide-react";
import {
  FaInstagram,
  FaTiktok,
  FaLinkedinIn,
  FaFacebookF,
  FaYoutube,
} from "react-icons/fa";
import { COMPANY, NAV } from "../../lib/constants";

const socials = [
  { icon: FaInstagram, label: "Instagram", color: "#E1306C" },
  { icon: FaTiktok, label: "TikTok", color: "#25F4EE" },
  { icon: FaLinkedinIn, label: "LinkedIn", color: "#0A66C2" },
  { icon: FaFacebookF, label: "Facebook", color: "#1877F2" },
  { icon: FaYoutube, label: "YouTube", color: "#FF3B30" },
];

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-zinc-800/80 bg-[#0a0a0c] z-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Link
              to="/"
              className="flex items-center gap-3"
              data-testid="footer-logo-link"
            >
              <img
                src={COMPANY.logoUrl}
                alt="RevMatrix"
                className="h-10 w-10 object-contain"
              />
              <span className="font-display text-xl font-extrabold tracking-tight">
                <span className="text-white">Rev</span>
                <span className="text-violet-500">Matrix</span>
              </span>
            </Link>
            <p className="mt-6 font-display text-2xl md:text-3xl font-extrabold tracking-tight text-white max-w-sm leading-tight">
              Performance Built To
              <span className="text-violet-400 ml-2">Scale</span>
            </p>
            <div className="mt-6 flex items-center gap-3">
              {socials.map(({ icon: Icon, label, color }) => (
                <a
                  key={label}
                  href="#"
                  aria-label={label}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  className="rm-social-chip h-10 w-10 border border-zinc-800 flex items-center justify-center text-zinc-400 transition-colors duration-300"
                  style={{ "--brand": color }}
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="rm-overline mb-5">Navigate</div>
            <ul className="flex flex-col gap-3">
              {NAV.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    data-testid={`footer-nav-${item.label.toLowerCase()}`}
                    className="text-zinc-300 hover:text-violet-400 transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="rm-overline mb-5">Get in touch</div>
            <ul className="flex flex-col gap-3 text-zinc-300">
              <li className="flex items-start gap-3">
                <Phone className="h-4 w-4 mt-1 text-violet-400 flex-shrink-0" />
                <a
                  href={COMPANY.phoneHref}
                  data-testid="footer-phone"
                  className="hover:text-violet-400 transition-colors"
                >
                  {COMPANY.phoneDisplay}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 mt-1 text-violet-400 flex-shrink-0" />
                <a
                  href={COMPANY.emailHref}
                  data-testid="footer-email"
                  className="hover:text-violet-400 transition-colors break-all"
                >
                  {COMPANY.email}
                </a>
              </li>
            </ul>
            <Link
              to="/contact"
              data-testid="footer-cta-contact"
              className="rm-btn-secondary mt-6 text-sm"
            >
              Book your free first call <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-zinc-800/80 flex items-center justify-center gap-3 text-xs font-mono text-zinc-500">
          <div>
            © {new Date().getFullYear()} RevMatrix. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};
